import React from 'react';
import icons from '@bbkAdminUtils/icons';
import { cs } from '@bbkAdminUtils/css-utils';

export const SuspenseLoader: React.FC<{ message?: string }> = ({ message }) => (
  <div
    className={cs(
      'tw-h-full tw-w-full',
      'tw-flex tw-items-center tw-justify-center',
      'tw-cursor-progress tw-text-cbrneutral-300',
      '[&_svg]:tw-h-16 [&_svg]:tw-w-16'
    )}
  >
    {icons.loaderSW6} {message ?? 'Loading...'}
  </div>
);
